import { safeApiRequest } from './apiClient';

/**
 * Stok ara: Parça adı veya kodu ile arama, hangi teknik serviste kaç adet var
 */
export const stokAra = async ({ q, sayfa = 1, limit = 50 } = {}) => {
  const params = { sayfa, limit };
  if (q && String(q).trim()) params.q = String(q).trim();
  const response = await safeApiRequest('/api/stok/ara', {
    method: 'GET',
    query: params,
    skipCsrf: true,
  });
  return response;
};

/**
 * Teknik servis listesi (stok sayfaları için)
 */
export const fetchTeknikServislerStok = async ({ arama, sayfa = 1, limit = 30 } = {}) => {
  const params = { sayfa, limit };
  if (arama && String(arama).trim()) params.arama = String(arama).trim();
  const response = await safeApiRequest('/api/stok/teknik-servisler', {
    method: 'GET',
    query: params,
    skipCsrf: true,
  });
  return response;
};

/**
 * Belirli teknik servisin stok listesi
 */
export const fetchTeknikServisStok = async (teknikServisId, { sayfa = 1, limit = 50 } = {}) => {
  const response = await safeApiRequest(`/api/stok/teknik-servis/${encodeURIComponent(teknikServisId)}`, {
    method: 'GET',
    query: { sayfa, limit },
    skipCsrf: true,
  });
  return response;
};
